module.exports = __webpack_public_path__ + "static/img/yg.b99ea8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yg.png
// module id = h+j1
// module chunks = 1